module.exports = __webpack_public_path__ + "static/img/zu19.a6a5daa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/zu19.png
// module id = Gix1
// module chunks = 1